module.exports = __webpack_public_path__ + "static/img/icon_googlepay.623845d7.png";